import { render, staticRenderFns } from "./ViewTickets.vue?vue&type=template&id=15c10b26&"
import script from "./ViewTickets.vue?vue&type=script&lang=js&"
export * from "./ViewTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports